<template>
  <div class="_pr _thumbnail">
    <canvas v-show="!loadingGifShow" ref="canvasRef"  class="_canvasStyle"/>
    <img v-show="loadingGifShow" :src="loadingGif" />
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    imageIds: {
      type: Array,
      required: true
    },
    id: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      loadingGifShow: false,
      loadingGif: require('@/assets/images/loading.gif')
    }
  },
  watch: {},
  computed: {},
  methods: {
    thumbnailInit () {
      this.loadingGifShow = true
    },
    thumbnailRenderToCanvas (canvasRef, image) {
      if (!canvasRef || !image) {
        return
      }
      this.loadingGifShow = false
      cornerstone.renderToCanvas(canvasRef, image)
    }
  },
  created () {},
  mounted () {
    // 初始化显示默认图片
    this.thumbnailInit()
    // 显示序略图
    cornerstone.loadAndCacheImage(this.imageIds[0]).then((image) => {
      this.thumbnailRenderToCanvas(this.$refs.canvasRef, image)
    })
  }
}
</script>
<style lang="scss" scoped>
  ._thumbnail {
    width: 100%;
    height: 100%;
    text-align: center;
    position: relative;
    img{
      width: 18px;
      height: 18px;
      position: absolute;
      left: 50%;
      top: 50%;
      margin-left: -9px;
      margin-top: -9px;
    }
  }
  ._canvasStyle{
    width: 100%;
    height: 100%;
  }
</style>
